function matchingColorValues(term, select) {
 const normalize = value => value.toLowerCase().replace(/grey/g, 'gray').replace(/[^a-z0-9]+/g, ' ').trim();
 const query = normalize(term).replace(/\b(shirts?|tees?|t shirts?|colors?|colour|matches|matching)\b/g, '').replace(/\s+/g, ' ').trim();
 if (!query) return [];
 const entries = [...select.options].filter(option => option.value).map(option => ({name: normalize(option.dataset.familyName || option.text), value: option.value}));
 const families = ['blue', 'green', 'gray', 'red', 'pink', 'purple', 'orange', 'yellow', 'brown', 'black', 'white'];
 if (families.includes(query)) return entries.filter(entry => entry.name.split(' ').includes(query) || (query === 'blue' && entry.name === 'navy')).flatMap(entry => entry.value.split(','));
 const exact = entries.filter(entry => entry.name === query);
 if (exact.length) return exact.flatMap(entry => entry.value.split(','));
 const aliases = {'navy blue': 'navy', 'camo': 'camouflage', 'forest green': 'dark forest green'};
 if (aliases[query]) return entries.filter(entry => entry.name === aliases[query]).flatMap(entry => entry.value.split(','));
 return [];
}
async function loadFinderColors(form) {
 const select = form.querySelector('[data-match-color]');
 if (select.options.length > 1) return;
 if (form.finderColorsRequest) return form.finderColorsRequest;
 select.disabled = true;
 form.finderColorsRequest = (async () => {
  const url = new URL(form.action, location.origin);
  url.searchParams.set('section_id', 'finder-color-options');
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id', preview);
  const response = await fetch(url.href, {signal: AbortSignal.timeout(8000)});
  if (!response.ok) throw new Error('Color options unavailable');
  const source = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-finder-color-source]');
  if (!source?.name || source.options.length < 2) throw new Error('Color options unavailable');
  select.name = source.name;
  select.replaceChildren(...[...source.options].map(option => option.cloneNode(true)));
  const suggestions = form.querySelector('datalist');
  suggestions.replaceChildren(...[...select.options].filter(option => option.value).map(option => {
   const suggestion = document.createElement('option');
   suggestion.value = option.textContent.trim();
   return suggestion;
  }));
 })().finally(() => {select.disabled = false;});
 return form.finderColorsRequest;
}
document.querySelectorAll('[data-match-form]').forEach(form => loadFinderColors(form).catch(() => {}));
document.addEventListener('submit', async event => {
 const form = event.target;
 if (!form.matches('[data-match-form]')) return;
 event.preventDefault();
 try {await loadFinderColors(form);} catch {}
 const select = form.querySelector('[data-match-color]');
 const sort = form.querySelector('[data-match-sort]');
 const term = form.querySelector('[data-match-search]').value.trim();
 const typedColors = matchingColorValues(term, select);
 const color = select.value || [...new Set(typedColors)].join(',');
 const searchTerm = typedColors.length ? '' : term;
 const url = new URL(searchTerm ? form.dataset.searchUrl : form.action, location.origin);
 if (color) color.split(',').forEach(value => url.searchParams.append(select.name, value));
 if (searchTerm) {
  url.searchParams.set('q', searchTerm);
  url.searchParams.set('type', 'product');
  url.searchParams.set('options[prefix]', 'last');
 }
 if (sort?.value && sort.value !== 'relevance') url.searchParams.set('sort_by', sort.value);
 const preview = new URLSearchParams(location.search).get('preview_theme_id');
 if (preview) url.searchParams.set('preview_theme_id', preview);
 location.assign(url.href);
});
function updateOptions(container){
 document.querySelectorAll('.product-form button[type="submit"], [data-sticky-bag] button').forEach(button=>{if(!button.disabled){button.dataset.variantPending='true';button.disabled=true;}});
 const selects=[...container.querySelectorAll('[data-option-select]')];
 const url=new URL(container.dataset.productUrl,location.origin);
 url.searchParams.set('option_values',selects.map(s=>s.value).join(','));
 // Keep Shopify theme preview context while selecting a variant.
 const preview=new URLSearchParams(location.search).get('preview_theme_id');
 if(preview)url.searchParams.set('preview_theme_id',preview);
 if(selects[0]?.id)url.hash=selects[0].id;
 location.assign(url.href);
}
document.addEventListener('change',event=>{
 if(!event.target.matches('[data-option-select]'))return;
 const container=event.target.closest('[data-options]');
 const target=event.target.selectedOptions[0].dataset.productUrl;
 if(target)container.dataset.productUrl=target;
 updateOptions(container);
});
document.addEventListener('click',event=>{
 if(event.target.matches('[data-update-options]'))updateOptions(event.target.closest('[data-options]'));
 if(!event.target.closest('.nav-category'))document.querySelectorAll('.nav-category[open]').forEach(d=>d.open=false);
});
document.addEventListener('keydown',event=>{
 if(event.key==='Escape')document.querySelectorAll('.nav-category[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()});
});



window.addEventListener('pageshow',()=>{document.querySelectorAll('[data-variant-pending]').forEach(button=>{button.disabled=false;delete button.dataset.variantPending;});});
